import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Dialog } from '@chilecompra/react-kit/components'
import { DialogContent, Link } from './PurchaseOrderDialog.styles'
import DataTable from '../../components/DataTable/DataTable'
import { onClosePurchaseOrderDialog } from './../UniqueSellersSection/UniqueSellersSection.actions'
/**
 * The PurchaseOrderDialog's container.
 */
const PurchaseOrderDialog = () => {
  const dispatch = useDispatch()
  const { open, orders } = useSelector(state => state.uniqueSeller)

  const columns = [
    { label: 'ID', value: 'id' },
    { label: 'Nombre', value: 'name' },
    { label: 'Estado', value: 'state' },
    { label: 'Fecha de envío', value: 'dateSend' }
  ]

  const handleClose = () => {
    dispatch(onClosePurchaseOrderDialog())
  }

  return (
    <Dialog maxWidth="800px" open={open} onClose={handleClose}>
      <DialogContent>
        <h1>Órdenes de compra bajo causal trato directo</h1>
        <DataTable
          headers={columns}
          initialPage={1}
          initialRows={5}
          headersCellsProps={[
            { enableFilter: false, enableSort: true, width: '30%' },
            { enableFilter: false, enableSort: true, width: '25%' },
            {
              width: '20%'
            },
            {
              width: '25%'
            }
          ]}
          records={orders}
          recordsDecorators={[
            ({ id, urlId }) => (
              <Link href={urlId} rel="noreferrer" target="_blank">
                {id}
              </Link>
            ),
            ({ name }) => name,
            ({ state }) => state,
            ({ dateSend }) => dateSend
          ]}
        />
      </DialogContent>
    </Dialog>
  )
}

export default PurchaseOrderDialog
